import React from 'react';

const Icon = ({ width = '21', height = '33', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 21 33" fill="none" {...other}>
            <path d="M10.485 28.287a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334Z" fill={fill} stroke={fill} strokeWidth="0.848" />

            <path d="M8.678 4.97h3.614" stroke={fill} strokeWidth="2.188" strokeLinecap="round" strokeLinejoin="round" />

            <path
                d="M15.976 2.063H4.994a3.085 3.085 0 0 0-3.085 3.085v22.704a3.085 3.085 0 0 0 3.085 3.085h10.982a3.085 3.085 0 0 0 3.085-3.085V5.148a3.085 3.085 0 0 0-3.085-3.085Z"
                stroke={fill}
                strokeWidth="2.188"
            />
        </svg>
    );
};
export default React.memo(Icon);
